import { HTTP } from "@/shared/services/Http.service";
import { URL_API_AUTENTICACION_V2_VU } from "../../utils/url.utils";
import type { 
    ConfiguracionVuRequest, 
    ConfiguracionVuResponse,
    ValidacionTokenVURequest,
    ValidacionTokenVUResponse,
    GuardarResultadoVURequest,
    GenerarEnlacePruebaVidaVURequest,
    CambioCorreoElectronicoRequest
} from "../../types/interfaces/AuntenticacionV2Vu";

const http = HTTP();

function GetConfiguracion(data: ConfiguracionVuRequest): Promise<ConfiguracionVuResponse> {
    return http.Post(URL_API_AUTENTICACION_V2_VU.CONFIGURACION, { body: data });
}

function ValidarTokenVU(data: ValidacionTokenVURequest): Promise<ValidacionTokenVUResponse> {
    return http.Post(URL_API_AUTENTICACION_V2_VU.VALIDAR_TOKEN, { body: {IdUsuario: data.id, Token: data.token, Email: data.email, IdConfigVU: 2, TipoPruebaVida: data.tipoPruebaVida }, skipAuth: true });
}

function GuardarResultadoVU(data: GuardarResultadoVURequest): Promise<any> {
    return http.Post(URL_API_AUTENTICACION_V2_VU.GUARDAR_RESULTADO, { body: data, skipAuth: true });
}


function GenerarEnlacePruebaVidaVU(data: GenerarEnlacePruebaVidaVURequest): Promise<{message: string}> {
    return http.Post(URL_API_AUTENTICACION_V2_VU.GENERAR_ENLACE_PRUEBA_VIDA, { body: data, skipAuth: true });
}

function guardarCambioCorreoElectronico(data: CambioCorreoElectronicoRequest): Promise<{message: string}> {
    return http.Post(`${URL_API_AUTENTICACION_V2_VU.CAMBIO_CORREO_ELECTRONICO}?Token=${data.token}&IdUsuario=${data.idUsuario}&NuevoEmail=${data.nuevoCorreo}`, { skipAuth: true });
}

export {
    GetConfiguracion,
    ValidarTokenVU,
    GuardarResultadoVU,
    GenerarEnlacePruebaVidaVU,
    guardarCambioCorreoElectronico 
}